module.exports = __webpack_public_path__ + "static/media/logoorange.1c5914f3.png";